module.exports = __webpack_public_path__ + "static/media/Team 11 - Carbon Switch.53206f09.png";